module.exports = __webpack_public_path__ + "static/media/notification.cb6d6048.png";